<template>
  <div class="top-right-btn">
    <el-row>
      <!-- 浏览方式 -->
      <el-tooltip v-if="showCompanyByType" class="viewtype" :content="$t('切换列表显示维度')" placement="top">
        <el-button-group>
            <el-button type="primary" icon="el-icon-s-operation" size="mini" :plain="activeTP" @click="changeListType(0)">{{$t('按企业')}}</el-button>
            <el-button type="primary" icon="el-icon-menu" size="mini" :plain="!activeTP" @click="changeListType(1)">{{$t('按集团')}}</el-button>
        </el-button-group>
      </el-tooltip>
      <!-- 搜索 -->
      <el-tooltip v-if="showSearch" class="item" effect="dark" :content="showSearch ? '隐藏搜索' : '显示搜索'" placement="top">
        <el-button size="mini" circle icon="el-icon-search" @click="toggleSearch()" />
      </el-tooltip>
      <!-- 导出数据 -->
      <el-tooltip class="item" effect="dark" :content="$t('导出数据')" placement="top" v-if="showExport">
        <el-button size="mini" circle icon="el-icon-tickets" @click="exportData()" />
      </el-tooltip>
      <!-- 刷新 -->
      <el-tooltip class="item" effect="dark" :content="$t('刷新')" placement="top">
        <el-button size="mini" circle icon="el-icon-refresh" @click="refresh()" />
      </el-tooltip>
      <!-- 列显示/隐藏 -->
      <el-tooltip class="item" effect="dark" :content="$t('显隐列')" placement="top" v-if="columns!=undefined">
        <el-dropdown
          trigger="click"
          :hide-on-click="false"
          style="padding-left: 12px;"
          @visible-change="visibleChange"
        >
          <el-button size="mini" circle icon="el-icon-menu"/>
            <el-dropdown-menu slot="dropdown" class="my-dropdown-menu">
              <div id="mySortClounm">
                <div v-for="(v, k) in arr" :key="k" :class="!(v.v_bind.fixed)?'my-sortitem':''" :data-prop="v.v_bind.prop">
                  <el-dropdown-item class="myelitemclass">
                      <el-checkbox
                        v-model="v.v_bind.isShow"
                        :label="v.v_bind.label"
                        @change="monitorChange($event, v.v_bind.label)"
                        class="elcheckbox"
                      ></el-checkbox>
                      <i class="el-icon-sort my-handle" v-if="!(v.v_bind.fixed)"></i>
                  </el-dropdown-item>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
      </el-tooltip>
    </el-row>
  </div>
</template>
<script>
import Sortable from 'sortablejs';
import { eventBus } from '@/main';
import { mapState } from "vuex";
export default {
  name: "table-right-toolbar",
  data() {
    return {
      // 显隐数据
      value: [],
      // 弹出层标题
      title: this.$t('显隐列'),
      // 是否显示弹出层
      open: true,
      // 激活的浏览方式
      activeTP: false,
      arr: [],
    };
  },
  props: {
    showSearch: {
      type: Boolean,
      default: false,
    },
    showCompanyByType:{
      type: Boolean,
      default: false,
    },
    showExport: {
        type: Boolean,
        default: false,
    },
    columns: {
      type: Array,
    },
  },
  computed:{
    ...mapState(["lists_sort_field"]),
  },
  watch:{
    // 路由切换activeTP恢复默认
    "$store.state.kslhow0s_search_list.qs.listtp"(listtp){
      this.$nextTick(()=>{
        if (listtp==0) {
          this.activeTP = false;
        } else {
          this.activeTP = true;
        }
      })
    }
  },
  // 在组件被添加到 DOM 后执行的代码 
  mounted() {
    let self = this;
    let sortableList = document.getElementById('mySortClounm');
    // 拖动排序
    new Sortable(sortableList, {
        animation: 150,
        handle: ".my-handle",
        ghostClass: 'ghostClass',
        draggable: ".my-sortitem",  // 允许拖拽的项目类名
        // 拖拽元素改变位置的时候
        // 结束拖拽
        onEnd: function (/**Event*/evt) {
          evt
          // 在排序结束时，获取新的行顺序
          const sortedRows = Array.from(sortableList.children);
          const sortedArr = sortedRows.map(row => {
              const prop = row.getAttribute('data-prop');
              return self.arr.find(column => column.v_bind.prop === prop);
          });
          // 存入stor
          self.lists_sort_field[self.$route.name] = [...sortedArr];
          // 拖动结束时：改变列表数顺序据
          eventBus.$emit('changeColumns',[...sortedArr])
        },
    });
  },
  methods: {
    // 搜索
    toggleSearch() {
      this.$emit("update:showSearch", !this.showSearch);
    },
    // 刷新表格
    refresh() {
      this.$emit("queryTable");
    },
    // 导出数据
    exportData(){
        this.$emit("exportData");
    },
    // 右侧列表元素变化
    dataChange(data) {
      for (var item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 筛选条件
    monitorChange(event, label){
      this.columns.filter(item=>item.v_bind.label==label)[0].v_bind.isShow=event
      this.$emit("changeSel", event,label);
    },
    changeListType: function(param){
      this.activeTP = !this.activeTP;
      this.$emit("changeListType", param);
    },
    // 列显示/隐藏时触发
    visibleChange(even){
      if (even) {
        // 初始化字段显示顺序
        let tmpfield = [...this.lists_sort_field[this.$route.name]]
        if (tmpfield.length==0) {
            this.arr = [...this.columns];
        }else{
            this.arr.splice(0,this.arr.length,...tmpfield);
        }
      }else{
        this.arr = [];
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.top-right-btn{
  width: 100%;
  height: 30px;
  text-align: right;
}
::v-deep .el-transfer__button {
  border-radius: 50%;
  padding: 12px;
  display: block;
  margin-left: 0px;
}
::v-deep .el-transfer__button:first-child {
  margin-bottom: 10px;
}
.my-dropdown-menu{
  max-height:580px;
  overflow-y:auto;
}
.elcheckbox{
  width: 100%;
}
::-webkit-scrollbar{
  width: 8px;
}
.viewtype{
    margin-right: 10px;
    .is-plain{
        color: #26a9a2;
        background: #e9f6f6;
        border-color: #a8ddda;
    }
}
.item_kd{
    width: 300px;
}
// 拖动排序
.ghostClass{
  background-color: #e9f6f6;
}
.myelitemclass{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>